import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';

import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { SelectFieldFloatingLabel } from '../../../../../common/custom-form/select-filter.component';
import { hrDetailsActions } from '../../../../../../store/external/manage-user/form/manage-user-form.reducer';
import { TRANSLATIONS as translation} from '../../../../../../utils/constant.utils';

class AccessManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: false
        }
    }

    handleToggle = () =>{
        this.setState(prev => ({isCollapsed: !prev.isCollapsed}))
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {isCollapsed} = this.state;
        const { translator, manageUserHrDetails, manageUserHrDetailsForm } = this.props;
        return (
            <div className="control-container">
                
            <CustomDropdown activeDropdown={isCollapsed} toggleActiveState={() => {this.handleToggle()}} label={translator("access_management")} >
                <div className={`add-sim-container detail-page-container details-4-col-container`}>
                    <SelectFieldFloatingLabel
                        className="form-select required"
                        label={this.toLocaleLanguage("role")}
                        options={manageUserHrDetails.roleDropdown}
                        value={manageUserHrDetailsForm.roleId ?? ""}
                        placeholder={this.toLocaleLanguage('select_placeholder')}
                        fieldProp='manageUserHrDetailsForm.roleId'
                        optionLabelKey={{
                            Key: "RoleId",
                            Value: "RoleName"
                        }}
                    />
                </div>
            </CustomDropdown>
        </div>
        );
    }
}


export default connect(
    state => {
        const { manageUserHrDetails, translation } = state;
        const { manageUserHrDetailsForm } = state.form;

        return {
            manageUserHrDetails,
            manageUserHrDetailsForm,
            translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, hrDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(AccessManagement);